import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, ArrowLeft } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-ink text-paper grid place-items-center px-6">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-paper/60 hover:text-paper text-sm mb-8 transition-colors">
          <ArrowLeft size={16} /> Back to site
        </Link>
        <div className="flex items-center gap-2 mb-8">
          <span className="w-10 h-10 bg-rust text-white grid place-items-center font-display font-black text-xl">G</span>
          <span className="font-display font-extrabold text-xl">Garage Cleaners</span>
        </div>
        <h1 className="font-display font-black text-4xl tracking-tight">Team Login</h1>
        <p className="mt-2 text-paper/50">Access the leads dashboard.</p>

        <form onSubmit={submit} data-testid="login-form" className="mt-8 space-y-5">
          <div>
            <Label htmlFor="email" className="font-mono text-xs uppercase tracking-widest text-paper/60">Email</Label>
            <Input id="email" data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-2 bg-surface-dark border-paper/20 text-paper focus-visible:ring-rust" placeholder="admin@garagecleaners.com" />
          </div>
          <div>
            <Label htmlFor="password" className="font-mono text-xs uppercase tracking-widest text-paper/60">Password</Label>
            <Input id="password" data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="mt-2 bg-surface-dark border-paper/20 text-paper focus-visible:ring-rust" placeholder="••••••••" />
          </div>
          {error && <p data-testid="login-error" className="text-sm text-rust">{error}</p>}
          <button type="submit" data-testid="login-submit" disabled={loading}
            className="w-full inline-flex items-center justify-center gap-2 bg-rust text-white px-6 py-3.5 font-semibold hover:bg-rust-dark transition-colors disabled:opacity-60">
            {loading ? <><Loader2 size={18} className="animate-spin" /> Signing in...</> : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
